// import { IS_SP } from '../const/config';

export class MoviePlayer {
  constructor() {
    this.DOM = {};
    this.DOM.players = document.querySelectorAll('[data-player]');

    if (!this.DOM.players) return;

    this.init();
  }

  init() {

    // タブグループごとの処理（複数のタブ設置に対応）
    this.DOM.players.forEach( (player) => {
      
      // const playerType = player.getAttribute('data-player');
      const video = player.querySelector('video');
      const thumbnail = player.querySelector('[data-player-thumbnail]');
      
      if(thumbnail){
        thumbnail.addEventListener('click', () => {

          if (video) {

            // サムネイルを非表示にする
            thumbnail.classList.add('is-played');

            // 動画を再生する
            video.play();
          }
        });
      }
    });

  }
}
